const GTM_LOADED_KEY = 'gtmLoaded'

export function pushUserData(user) {
  if (typeof window === 'undefined' || !window.dataLayer || !user) return
  const cohort = user.memberCohort?.trim() || undefined
  const years = (user.NoOfYrsintheIndustry !== null && user.NoOfYrsintheIndustry !== undefined && user.NoOfYrsintheIndustry !== '')
    ? user.NoOfYrsintheIndustry
    : undefined
  window.dataLayer.push({
    userId: user.id,
    cohort,
    yearsInIndustry: years,
  })
}

export function loadGTM(containerId) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window[GTM_LOADED_KEY]) return
  window[GTM_LOADED_KEY] = true

  const w = window
  const d = document
  const s = 'script'
  const l = 'dataLayer'
  w[l] = w[l] || []
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
  const f = d.getElementsByTagName(s)[0]
  const j = d.createElement(s)
  const dl = l !== 'dataLayer' ? '&l=' + l : ''
  j.async = true
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId + dl
  f.parentNode.insertBefore(j, f)
}

export function pushEvent(eventName, eventParams = {}) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventParams,
    })
  }
}